import type { LexicalNode, NodeKey } from 'lexical';
import { $getNodeByKey } from 'lexical';

/** The node for `key` if it still exists and passes `isType`; for updates that may race a deletion. */
export const $getNodeOfType = <T extends LexicalNode>(key: NodeKey, isType: (node: LexicalNode | null | undefined) => node is T): T | null => {
  const node = $getNodeByKey(key);
  return isType(node) ? node : null;
};
